import Cover from "./Cover/index";

export default {
  Cover
};
